/// <reference path="../ProjectFinder2/ProjectFinderHomeLM.ts" />
//import AgendaViewBase = require("../AgendaViewBase/AgendaViewBase");
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import "../../moreCore/UI/GenericDialog/GenericDialog";
import { EvBookingEditor, VAMtypes, EvBookingView, RoomBlockingForm } from "../_loadingHelpers/VAM";

import EvBookingAgenda from './EvBookingAgenda';

class MozEvBookingAgenda extends compose(EvBookingAgenda) {

    openDetailView(row: StaticTable.StaticTableRow<VAMtypes.EvBookingEditorEntity>, rowGroup: StaticTable.StaticTableRowGroup<VAMtypes.EvBookingEditorEntity>) { 

        let entity = rowGroup.entity;
        //debugger;
        let editor = new EvBookingView();
        editor.setup(entity.ID, entity.ev_booking_name, { "mozApprovalBookingMode": true } );
        editor.startup();
        

    }
   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setupAgendaView(
            "EventFinder/GetMozAgendaFilterOptions",
            "EventFinder/GetMozAgendaEventList",
            lang.hitch(this, this.openDetailView),
            null, // Standard-Formatter
            null
        );

        this.setTitles(this.translations["EvBooking_AgendaMainTitle"]);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MozEvBookingAgenda);